import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const PrivateRoute = (props) => {
    const { component: Component, authenticated, role, allowRoles, ...rest } = props;
    return <Route
        {...rest}
        render={props =>
            authenticated === true ? 
                allowRoles && allowRoles.length && allowRoles.find(r => r === role) == null ? //we're restricting the roles and the user doesn't have the required role, redirect to the home page
                    <Redirect to="/" />
                    : 
                    <Component {...props} /> 
                :
                <Redirect to="/Login" />
            }
    />
} 

PrivateRoute.propTypes = {
    authenticated: PropTypes.bool.isRequired
};

export default PrivateRoute;